import { PASSCODE_LIST_TYPE, PasscodeList } from '@/types/registration.types';
import Container from '@ui/container/container';
import Icon from '@ui/icons/icon';
import Text from '@ui/text/text/text';
import { ICONS } from '@ui/icons/types';

import styles from './add-new-passcode-list-card.module.css';
import classNames from 'classnames';
import Button from '@ui/buttons/button/button';
import { Dispatch, SetStateAction, useState } from 'react';

type PasscodeListCardRowProps = {
  passcodeList: PasscodeList;
  onClick?: Dispatch<SetStateAction<number>>;
};

type PasscodeListDisplayParams = {
  title: string;
  gradientClass: string;
};

const PasscodeListDisplayProps: Record<number, PasscodeListDisplayParams> = {
  [PASSCODE_LIST_TYPE.EMAILS_ONLY]: { title: 'Emails', gradientClass: 'gradient-blue' },
  [PASSCODE_LIST_TYPE.PASSCODES_ONLY]: { title: 'Passcodes', gradientClass: 'gradient-yellow' },
  [PASSCODE_LIST_TYPE.EMAILS_AND_PASSCODES]: { title: 'Email & Passcode', gradientClass: 'gradient-pink' },
  [PASSCODE_LIST_TYPE.MAGIC_LINKS]: { title: 'Magic Links', gradientClass: 'gradient-red' },
};

const PasscodeListCardRow = ({ passcodeList, onClick }: PasscodeListCardRowProps) => {
  const [selected, setSelected] = useState(false);

  return (
    <Button
      className="no-style padding-0"
      width="100%"
      onClick={() => {
        setSelected(!selected);
        if (onClick) {
          onClick(passcodeList.passcode_list || 0);
        }
      }}
      backgroundColor="transparent"
    >
      <Container
        borderRadius="16px"
        borderColor={selected ? 'var(--white-100)' : 'transparent'}
        borderWidth="1px"
        className={classNames(
          'padding-20 flex-row flex jc-space-between radius-16',
          styles[PasscodeListDisplayProps[passcodeList.type]?.gradientClass || '']
        )}
      >
        <Container className="overflow-hidden flex fd-row jc-flex-start" width="auto" background="transparent">
          <Text tag="h5" clamp={1} wordBreak="break-all" className="H5">
            {passcodeList.name}
          </Text>
        </Container>

        <Container
          className="flex fd-row jc-flex-end ai-center"
          width="200px"
          background="transparent"
          minWidth="200px"
        >
          <Container
            background="var(--gray-900)"
            padding="8px 10px"
            className="flex fd-row jc-flex-end radius-8"
            style={{ lineHeight: '11px' }}
          >
            <Text fontSize={'11px'} clamp={1}>
              {PasscodeListDisplayProps[passcodeList.type]?.title || 'no match'}
            </Text>
          </Container>
          <Container
            background="var(--gray-900)"
            padding="8px 10px"
            className="flex fd-row jc-flex-end radius-8 margin-l-8"
            style={{ lineHeight: '11px' }}
          >
            <Icon name={ICONS.PEOPLE_NAV} size={11} color="gray" />
            <Text fontSize={'11px'} clamp={1} className="margin-l-4">
              {passcodeList.member_count}
            </Text>
          </Container>
        </Container>
      </Container>
    </Button>
  );
};

export default PasscodeListCardRow;
